function NewChannel() {
    return {
        id: null,       
        name: "",		
		channels: [],
        _isNew: true
      }
}
export default NewChannel;